import styled from '@emotion/styled';
import { Input, Lens } from '@innovationdepartment/proxima-ui';
import LoadingBar from 'ui/LoadingBar';
import BrandProductsTaxonomyChangeModalProductsToUpdate from './BrandProducts.TaxonomyChangeModal.ProductsToUpdate';
import BrandProductsTaxonomyChangeModalTaxonomyList from './BrandProducts.TaxonomyChangeModal.TaxonomyList';
import type { TaxonomyChangeModalViewProps } from './types';

const ContainerWrapper = styled.div`
  width: 800px;
  display: flex;
  & > :first-child {
    margin-top: -20px;
  }
`;

const SearchContainer = styled.div`
  flex: 1;
  padding: 0 8px;
`;

const SearchWrapper = styled.div`
  margin: 0 0 16px 0;
`;

const BrandProductsTaxonomyChangeModalView = (props: TaxonomyChangeModalViewProps) => {
  const { products, loading, onSearchChange } = props;

  if (!products.length) return null;

  return (
    <ContainerWrapper>
      <LoadingBar loading={loading} />
      <BrandProductsTaxonomyChangeModalProductsToUpdate {...props} />
      <SearchContainer>
        <SearchWrapper>
          {/* TODO(Jenky): filter */}
          <Input
            placeholder="Search for a new category"
            fullWidth
            value=""
            onChange={onSearchChange}
            startAdornment={<Lens />}
          />
        </SearchWrapper>
        <BrandProductsTaxonomyChangeModalTaxonomyList {...props} />
      </SearchContainer>
    </ContainerWrapper>
  );
};

export default BrandProductsTaxonomyChangeModalView;
